import Vue from 'vue';
import { Toast, Lazyload, Popup, Icon, Dialog, NavBar, Overlay, Cell, CellGroup } from 'vant';
import { Image as VanImage } from 'vant';
import 'vant/lib/index.css';

Vue.use(Toast);
Vue.use(VanImage);
Vue.use(Lazyload);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(NavBar);
Vue.use(Dialog);
Vue.use(Overlay);
Vue.use(Cell);
Vue.use(CellGroup);

Vue.prototype.$Toast = Toast